export default __webpack_public_path__ + "628b585931b6c6bba445b90fb82db197.wav";